import styles from './Banner.module.css';
import coloredCicle from '../../assets/circulo_colorido.png';
import foto from '../../assets/banner-foto.jpeg'

export default function Banner() {
    return (
        <div className={styles.banner}>
            <div >
                <h1 className={styles.title}>
                    Olá pessoal :)
                </h1>

                <p className={styles.paragraph}>
                    Sejam bem-vindos ao meu espaço!!! Sou Fábio Ramos, Software Engineer Java, adorador da natureza e pai do Pedro no tempo Livre :D.
                    <br/><br/>Aqui você encontrará um pouco sobre minha trajetória profissional, projetos que participei e experiências...
                </p>
            </div>

            <div className={styles.images}>
                <img
                    className={styles.coloredCicle}
                    src={coloredCicle}
                    aria-hidden={true}
                    alt=""
                />

                <img
                    className={styles.foto}
                    src={foto}
                    alt="Foto"
                />
            </div>
        </div>
    )
}